module.exports = __webpack_public_path__ + "static/img/Bottles@2x.040d8f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sodastream/Bottles@2x.png
// module id = /M9K
// module chunks = 0